import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { PromiseSection } from './components/PromiseSection';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { SocialProofSection } from './components/SocialProofSection';
import { QualificationSection } from './components/QualificationSection';
import { BaseOfferSection } from './components/BaseOfferSection';
import { EliteOfferSection } from './components/EliteOfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { StickyCTA } from './components/StickyCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-dark font-sans selection:bg-brand-orange selection:text-white pb-20 md:pb-0" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <PromiseSection data-id="element-3" />
      <ProductSection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <SocialProofSection data-id="element-6" />
      <QualificationSection data-id="element-7" />
      <BaseOfferSection data-id="element-8" />
      <EliteOfferSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <FinalCTASection data-id="element-12" />

      <StickyCTA data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
    </div>;
}